<template>
  <b-form-group
      label="E-mail"
      label-for="email"
  >
    <validation-provider
      #default="{ errors }"
      name="E-mail"
      rules="required"
    >
      <b-form-input
        id="email"
        v-model="itemData.email"
        placeholder="E-mail"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'TitleText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['teams/dataItem']
    },
  },
}
</script>
